import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useLocation, useNavigate } from 'react-router-dom';
import { Switch } from 'antd';
import { useTranslation } from 'react-i18next';
import SimpleResourceLandingLayout from '../../components/layouts/SimpleResourceLandingLayout';
import columns from './columns';
import useAuthContext from '../../contexts/AuthContext';
import { routes, subRoutes } from '../../utils/constants/routes';

const ListTickets = ({ contractsStatus }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const { t } = useTranslation();
  const { user } = useAuthContext();
  const [switchFilter, setSwitchFilter] = useState(false);

  const showAmendments = location.pathname.includes(
    '/contracts/amendmentsinexemption'
  );

  return (
    <SimpleResourceLandingLayout
      tradKey={showAmendments ? 'amendments' : undefined}
      extraQuery={`amendment=${showAmendments ? 'YES' : 'NO'}&${
        state === 'AWAITING_INFORMATION'
          ? 'status=AWAITING_INFORMATION'
          : switchFilter
            ? `status!=IN_PROGRESS`
            : ''
      }${user?.permissionManagement?.quotations ? '' : `&user=${user?._id}`}`}
      withCreateButton={false}
      withUploadButton={false}
      onDoubleClickAction={{
        action: (record) =>
          navigate(
            `${
              contractsStatus === 'QUOTE'
                ? `${routes.QUOTES}${subRoutes.QUOTES.QUOTES_IN_EXEMPTION}`
                : `${routes.CONTRACTS}${subRoutes.CONTRACTS.PORTFOLIO_AMENDMENTS}`
            }/show/${record?.contract?._id}`
          )
      }}
      showAction={{
        pathname: (record) =>
          `${
            contractsStatus === 'QUOTE'
              ? `${routes.QUOTES}${subRoutes.QUOTES.QUOTES_IN_EXEMPTION}`
              : `${routes.CONTRACTS}${subRoutes.CONTRACTS.PORTFOLIO_AMENDMENTS}`
          }/show/${record?.contract?._id}`
      }}
      editAction={false}
      deleteAction={false}
      resourceName="tickets"
      columns={columns()}
      populate="contract,assignee,ticket_messages.author"
    >
      <Switch
        checkedChildren={t('tickets.switch.no_filter')}
        unCheckedChildren={t('tickets.switch.filter_answer')}
        onChange={() => setSwitchFilter(!switchFilter)}
        className="exemption-switch"
        defaultChecked
      />
    </SimpleResourceLandingLayout>
  );
};

ListTickets.propTypes = {
  contractsStatus: PropTypes.oneOf(['QUOTE', 'VALIDATED'])
};

ListTickets.defaultProps = {
  contractsStatus: 'QUOTE'
};

export default ListTickets;
